import React from 'react';
import {
  ForgotPassword as BaseForgotPassword
} from 'aws-amplify-react';
import RequestNewPasswordForm from './ForgotPassword/RequestNewPasswordForm';
import UpdatePasswordForm from './ForgotPassword/UpdatePasswordForm';
import AuthWrapper from './AuthWrapper';

export default class ForgotPassword extends BaseForgotPassword {
  componentDidUpdate(prevProps, prevState) {
    if (
      (prevProps.authState !== this.props.authState &&
        prevProps.authState === 'forgotPassword') ||
      prevState.delivery !== this.state.delivery
    ) {
      this.setState({
        working: false,
        errorMessage: false
      });
    }
  }

  error = errorMessage => {
    setTimeout(() => {
      this.setState({
        working: false,
        errorMessage: this.errorMessage(errorMessage)
      });
    }, 1000);
  };

  handleRequest = ({ email }) => {
    this.inputs.username = email;
    this.inputs.email = email;

    this.setState({
      working: true,
      errorMessage: false,
    }, () => {
      this.send();
    });
  }

  handleUpdate = ({ code, password }) => {
    this.inputs.code = code;
    this.inputs.password = password;

    this.setState({
      working: true,
      errorMessage: false,
    }, () => {
      this.submit();
    });
  }

  showComponent() {
    const {
      hide
    } = this.props;
    const {
      delivery,
      working = false,
      errorMessage = false
    } = this.state || {};
    if (hide && hide.includes(ForgotPassword)) {
      return null;
    }

    if (!delivery) {
      return (
        <AuthWrapper
          title="Forgot Password"
        >
          <RequestNewPasswordForm
            onSubmit={this.handleRequest}
            changeState={this.changeState}
            errorMessage={errorMessage}
            working={working}
          />
        </AuthWrapper>
      )
    }

    return (
      <AuthWrapper
        title="New Password"
      >
        <UpdatePasswordForm
          onSubmit={this.handleUpdate}
          changeState={this.changeState}
          errorMessage={errorMessage}
          working={working}
        />
      </AuthWrapper>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Authentication/ForgotPassword.js